import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'contact',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'contact',
				),
			store,
			'CONTACT',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Contact/index.js